import { render, staticRenderFns } from "./RowButtonComponent.vue?vue&type=template&id=028efa3c&scoped=true&"
import script from "./RowButtonComponent.vue?vue&type=script&lang=js&"
export * from "./RowButtonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028efa3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/driehle1/rezeptdatenbank/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028efa3c')) {
      api.createRecord('028efa3c', component.options)
    } else {
      api.reload('028efa3c', component.options)
    }
    module.hot.accept("./RowButtonComponent.vue?vue&type=template&id=028efa3c&scoped=true&", function () {
      api.rerender('028efa3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/trip-remains-list/RowButtonComponent.vue"
export default component.exports